import apicontratoweb from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apicontratoweb.get('contrato', { params: { ...where, ...params } }),
        apicontratoweb.get('contrato/count', { params: where }),
      ]);

      return { data, total };
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apicontratoweb.get('contrato');

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apicontratoweb.get(`contrato/${id}`);
      return data;
    },

    async findByNumero(_, { id }) {
      const { data } = await apicontratoweb.get(`contrato/numero/${id}`);
      return data;
    },

    async findFiltroImagem(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apicontratoweb.get('contrato/imagem', { params: { ...where } }),
      ]);

      return { data };
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
